module.exports = __webpack_public_path__ + "img/DE00438.1bf25997.png";